module.exports = __webpack_public_path__ + "assets/img/app-dec4.8491817a.svg";